// Accordion expand/collapse functionality
export function initCopyToClipboard() {
    const copyToClipboardButtons = document.querySelectorAll('.copy-to-clipboard');

    copyToClipboardButtons.forEach((button) => {
        button.addEventListener('click', async (e) => {
            e.preventDefault();
            const textToCopy = button.getAttribute('data-clipboard-text');
            if (!textToCopy) return;

            // Ensure button is focused
            if (button instanceof HTMLElement) {
                button.focus();
            }

            try {
                // Try modern Clipboard API first
                if (navigator.clipboard && window.isSecureContext) {
                    await navigator.clipboard.writeText(textToCopy);
                } else {
                    // Fallback to execCommand for older browsers or non-secure contexts
                    const textArea = document.createElement('textarea');
                    textArea.value = textToCopy;
                    textArea.style.position = 'fixed';
                    textArea.style.left = '-999999px';
                    textArea.style.top = '-999999px';
                    document.body.appendChild(textArea);
                    textArea.focus();
                    textArea.select();

                    const successful = document.execCommand('copy');
                    document.body.removeChild(textArea);

                    if (!successful) {
                        throw new Error('execCommand failed');
                    }
                }

                // Provide user feedback
                const originalText = button.innerHTML;
                button.innerHTML = 'Copied to Clipboard!';
                setTimeout(() => {
                    button.innerHTML = originalText;
                }, 2000);
            } catch (err) {
                console.error('Failed to copy text: ', err);

                // Show error feedback to user
                const originalText = button.innerHTML;
                button.innerHTML = 'Copy failed';
                setTimeout(() => {
                    button.innerHTML = originalText;
                }, 2000);
            }
        });
    });


}
